export default {
    props: ["isVisible"],
    data: function () {
        return {};
    },
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Spinner.vue
// module id = 333
// module chunks = 1